<template>
  <div class="text-center responsive-text">
    <div class="d-flex">
      <template v-for="(actor, index) in getActorsOnInfoPanel">
        <span :key="`d-${actor.id}`" v-if="index>0" class="mx-2">▪</span>
        <status
          :key="`s-${actor.id}`"
          :actor="actor"
          on-tile
        />
      </template>
    </div>
    <div>
      <strong>{{ getName }}</strong>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Status from '@/components/services/service/Status.vue';

export default {
  name: 'IcoolStatus',
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'getActorsOnInfoPanel',
    ]),
    getName() {
      return this.$store.state.snapshot.currentSnapshot
        ? this.$store.state.snapshot.currentSnapshot.name
        : '';
    },
  },
  methods: {},
  components: {
    Status,
  },
};
</script>

<style scoped lang="scss">
</style>
n
